export type BusinessModel = 'B2B' | 'B2C';
